import { ErrorMessage } from 'formik';

const ErrorMsg = ({ name }) => (
    <ErrorMessage as='p' name={name} render={(msg) => <p className='text-danger'>{msg}</p>} />
);

export default ErrorMsg;
